/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useState } from "react";
import { BannerDetails, ProfileDetails, listTiming, viewCertificate } from "../core/_requests";
import { useAuth } from "../../../auth";

import { BioUpdate } from "./BioUpdate";
import { ChangePassword } from "./ChangePassword";
import { UpdateBanner } from "./BannerPicture";
import { ChangeChefTiming } from "./ChangeChefTiming";
import { ProfileUpdate } from "./ProfileUpdate";
import { ProfilePicUpdate } from "./ProfilePic";
import { BrandUpdate } from "./BrandUpdate";
import { SoundUpdate } from "./SoundUpdate";
import { EditCertificate } from "./EditCertificate";
import { useParams } from "react-router-dom";


export const ProfileUpdateWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);
  if (data) {
    return <ProfileUpdate initialValues={data}/>;
  }
  return null;
};
export const ProfilePicUpdateWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);
  if (data) {
    return <ProfilePicUpdate initialValues={data}/>;
  }
  return null;
};
export const BioWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);
  if (data) {
    return <BioUpdate initialValues={data}/>;
  }
  return null;
};
export const BrandWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);
  if (data) {
    return <BrandUpdate initialValues={data}/>;
  }
  return null;
};
export const ProfilePictureWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);
};

export const BannerWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
    useEffect(() => {
    BannerDetails(currentUser?.uuid).then((res) => {
            setData(res.data);
    });
  }, []);

  if (data !== null && data !== undefined) {
    return <UpdateBanner initialValues={data} />;
  }
  return null;
};

export const ChangePasswordWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);

  if (data) {
    return <ChangePassword initialValues={data} />;
  }
  return null;
};
export const SoundUpdateWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  useEffect(() => {
    ProfileDetails(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);
  if (data) {
    return <SoundUpdate initialValues={data}/>;
  }
  return null;
};
export const ChefTimingWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null)

  useEffect(() => {
    listTiming(currentUser?.uuid).then((res) => {
      setData(res.data);
    });
  }, []);

  if (data) {
    return <ChangeChefTiming initialValues={data} />;
  }
  return null;
};

export const CertificateWrapper = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState<any>(null);
  const { id } = useParams();
    useEffect(() => {
    viewCertificate(id).then((res) => {
            setData(res.data);
    });
  }, []);

  if (data !== null && data !== undefined) {
    return <EditCertificate initialValues={data} />;
  }
  return null;
};